// extracted by mini-css-extract-plugin
module.exports = {"container_tab":"cabtab_container_tab__oLPBa","item_tab":"cabtab_item_tab__Qna8Y","active":"cabtab_active__2VV1W"};